<template>
  <div class="text-start">
    <label
      :for="id"
      class="form-label fw-bold d-flex justify-content-between align-items-center"
      ><div>{{ content }}</div>
    </label>
    <input
      v-if="!localFileURL"
      class="form-control"
      type="file"
      :id="id"
      :accept="getTypeObject.accept"
      @change="handleFileUpload($event)"
    />
  </div>
  <div v-if="showError" class="mt-3">
    <CustomAlert
      class="mb-0"
      type="danger"
      content="File size exceeds the 15MB limit. Please choose a smaller file."
    />
  </div>

  <!-- Image Preview -->
  <div v-if="localFileURL && subtype === 'image'" class="text-start mt-1">
    <img
      :src="localFileURL"
      class="img-fluid mb-2 rounded shadow-sm"
      alt="Uploaded Image"
    />

    <br />

    <button class="btn btn-link text-danger fw-bold" @click="removeFile()">
      Remove {{ getTypeObject.label }}
    </button>
  </div>

  <!-- PDF Preview -->
  <div v-if="localFileURL && subtype === 'pdf'" class="text-start">
    <button class="btn btn-link text-primary fw-bold" @click="downloadPDF()">
      Download {{ getTypeObject.label }}
    </button>

    <button class="btn btn-link text-danger fw-bold" @click="removeFile()">
      Remove {{ getTypeObject.label }}
    </button>
  </div>
</template>

<script>
// Eventually add max file size
const TYPES = {
  image: { label: "Image", accept: "image/*", maxSize: 15 },
  pdf: { label: "PDF", accept: "application/pdf", maxSize: 50 },
  all: { label: "File", accept: "*/*", maxSize: 15 }
};

import AssetsAPI from "@/helpers/AssetsAPI";

export default {
  name: "FormFile",
  mixins: [AssetsAPI],
  components: {},
  data() {
    return {
      localFileURL: "",
      showError: false
    };
  },
  props: {
    id: String,
    content: String,
    subtype: String,
    fileURL: String
  },
  emits: ["updateFileURL"],
  computed: {
    acceptedFileTypes() {
      return TYPES[this.subtype] || TYPES.all;
    },
    getTypeObject() {
      return TYPES[this.subtype] || TYPES.all;
    },
    isFieldComplete() {
      return !!this.localFileURL;
    }
  },
  methods: {
    handleFileUpload(event) {
      this.showError = false;
      const file = event.target.files[0];

      console.log("FILE UPLOAD:", file);
      if (file) {
        //
        // Check file size
        //
        const MB = 1024 * 1024; // 1MB
        const MB_LIMIT = this.getTypeObject.maxSize * MB; // Max size based on type

        if (file.size >= MB_LIMIT) {
          console.log("Size", file.size);
          this.showError = true;

          return false;
        }

        if (this.subtype === "image") {
          this.uploadImage(file, (url) => {
            this.localFileURL = url;
            this.$emit("updateFileURL", url);
          });
        } else if (this.subtype === "pdf") {
          this.uploadPDF(file, (url) => {
            this.localFileURL = URL.createObjectURL(file);
            console.log(this.localFileURL);
            this.$emit("updateFileURL", url);
          });
        }
      }
    },
    downloadPDF() {
      const a = document.createElement("a");
      a.href = this.localFileURL;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    removeFile() {
      this.localFileURL = "";
      this.$emit("updateFileURL", this.localFileURL);
    }
  },
  mounted() {
    //
    // If there's an existing file URL, set it to localFileURL
    //
    if (this.fileURL) {
      this.localFileURL = this.fileURL;
      console.log(this.localFileURL);
    }
  }
  /* lifecycle hooks */
};
</script>

<style scoped>
img {
  max-width: 50%; /* Ensure the image fits its container width */
  height: auto; /* Maintain aspect ratio */
}
</style>
